module.exports = __webpack_public_path__ + "images/drawings/moon/waxing-crescent.3127d58d67ac4255489557bbc8fb9934.png";